import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";

interface FeedFormProps {
  onSubmit: (oldFeed: File, newFeed: File) => void;
}

const FeedForm = forwardRef<unknown, FeedFormProps>(({ onSubmit }, ref) => {
  const [oldFeed, setOldFeed] = useState<File | null>(null);
  const [newFeed, setNewFeed] = useState<File | null>(null);
  const [fileSizeWarning, setFileSizeWarning] = useState<string | null>(null);

  const oldFeedInputRef = useRef<HTMLInputElement>(null);
  const newFeedInputRef = useRef<HTMLInputElement>(null);

  const MAX_FILE_SIZE_MB = 40;

  useImperativeHandle(ref, () => ({
    resetForm: () => {
      setOldFeed(null);
      setNewFeed(null);
      if (oldFeedInputRef.current) oldFeedInputRef.current.value = "";
      if (newFeedInputRef.current) newFeedInputRef.current.value = "";
    },
  }));

  const handleFileChange = (
    file: File | null,
    setFile: React.Dispatch<React.SetStateAction<File | null>>,
  ) => {
    if (file) {
      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB && !fileSizeWarning) {
        setFileSizeWarning(
          "Produktový feed je větší, zpracování může chvíli trvat.",
        );
      }
      setFile(file);
    }
  };

  const resetSizeWarning = () => {
    setFileSizeWarning(null);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (oldFeed && newFeed) {
      onSubmit(oldFeed, newFeed);
    } else {
      alert("Prosím, nahraj oba XML soubory.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label htmlFor="old_feed">Původní/starý feed:</label>
        <p className="file-hint">Ten kde je více produktů</p>
        <input
          type="file"
          id="old_feed"
          accept=".xml"
          ref={oldFeedInputRef}
          onChange={(e) =>
            handleFileChange(
              e.target.files ? e.target.files[0] : null,
              setOldFeed,
            )
          }
          required
        />
      </div>
      <div>
        <label htmlFor="new_feed">Současný feed:</label>
        <p className="file-hint">Ten kde produkty vypadly</p>
        <input
          type="file"
          id="new_feed"
          accept=".xml"
          ref={newFeedInputRef}
          onChange={(e) =>
            handleFileChange(
              e.target.files ? e.target.files[0] : null,
              setNewFeed,
            )
          }
          required
        />
      </div>
      {fileSizeWarning && (
        <>
          <p className="file-warning">{fileSizeWarning}</p>
          <p className="file-warning-error">Pokud to spadne, napiš mi 🤝🏻</p>
        </>
      )}

      <div>
        <button type="submit" onClick={resetSizeWarning}>
          Porovnat
        </button>
      </div>
    </form>
  );
});

export default FeedForm;
